import { graphql } from '@apollo/client/react/hoc';
import compose from 'recompose/compose';

import listingQuery from '../../../graphql/queries/publicListingsByOwner.graphql';

import Component from './EmbedPropertyList';

export default compose(
  graphql(listingQuery, {
    options: (ownProps) => ({
      variables: {
        id: ownProps.match.params.id,
      },
    }),
    props: ({ ownProps, data: { loading, viewer } }) => {
      return {
        loading,
        properties: viewer && viewer.ownerListings,
        ...ownProps,
      };
    },
  }),
)(Component);
